@use '@/sass/variables';

.InputWrapper {
  padding: 5px 10px;
  height: 40px;
  box-sizing: border-box;
  align-items: baseline;

  &:focus-within {
    outline: 0;
    box-shadow: 0 0 0 variables.$border-width-apitable variables.$blue;
    border-color: variables.$blue;

    .Chip {
      display: none;
    }
  }

  &.Error {
    border-color: variables.$red !important;
    color: variables.$near-black;
    box-shadow: 0px 0px 0px 1px variables.$red;

    &:focus-within {
      box-shadow: 0px 0px 0px 1px variables.$red;
      border-color: variables.$red;
    }

    .Chip {
      background: variables.$washed-red;
      color: variables.$dark-red;
    }
  }

  input {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;

    &:focus {
      outline: none !important;
      box-shadow: none !important;
      border: none !important;
    }
  }
}

.Chip {
  background: variables.$moon-gray;
  color: variables.$near-black;
  padding-top: 2px;
  padding-bottom: 2px;
}

.ClearButton {
  color: variables.$dark-gray;

  &:hover {
    color: variables.$dark-red;
  }
}
